import {spawnErrorToast, spawnSuccessToast} from '@hm/fundamental'
import {useQueryClient} from '@tanstack/react-query'
import {useTranslation} from 'react-i18next'

import {useRefraPlanningTracking} from '../tracking'

import {mutations} from '@refra/api/mutations'
import {useRefraMutation} from '@refra/modules/common/hooks'
import {logger} from '@refra/modules/common/utils'

interface UseAddShutdownParams {
  onSuccessCallback?: () => void
}

export const useAddShutdown = ({onSuccessCallback}: UseAddShutdownParams) => {
  const {t} = useTranslation()
  const queryClient = useQueryClient()
  const tracking = useRefraPlanningTracking()

  return useRefraMutation({
    mutationFn: mutations.addShutdown,
    onError: (error) => {
      const errorDetails = error?.response?.data.detail ?? error.message ?? error.response?.status
      logger
        .context('useAddShutdown')
        .extras({errorDetails})
        .error('Error occurred while adding a new shutdown')

      spawnErrorToast(t('error.addShutdown'))
    },
    onSuccess: async () => {
      tracking.shutdown.add()

      onSuccessCallback?.()
      await queryClient.invalidateQueries({queryKey: ['shutdowns']})
      spawnSuccessToast(t('success.addShutdown'))
    }
  })
}
